import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAdUser } from '../../reducers/auth-slice';


const IntakeSuccess = () => {
    const navigate = useNavigate();
    const adUser = useSelector(selectAdUser);

    // if order is a draft, display different success message
    const [queryStringParams, setQueryStringParams] = useSearchParams();
    const draft = queryStringParams.get('draft');

    /**
     * handle the close button
     */
    const handleClose = () => {
        if (adUser && adUser.adUser) {
            navigate("/");    
        } else {
            window.location.href = "https://glucroftinvestigations.com/"
        }
    };


    /**
     * handle the add new
     */
    const handleAddNew = () => {
        navigate("/intake/general-information");
    };


    return (
        <div className="page">
            <div className="success">
                <div className="left">
                    <h2>Success!</h2>
                </div>
                <div className="right">
                    <button className="button primary" type="button" onClick={handleClose}>Close</button>
                    <button className="button tertiary" type="button" onClick={handleAddNew}>+ Add New Order</button>
                </div>
            </div>
            {draft ? 
            <div>
                <h3>Your order has been successfully saved as a draft.</h3>
                <h5>Navigate to the orders page to view and continue working on your order.</h5>
            </div> : 
            <div>
                <h3>We have received your submission; thank you! We will turn around your order as quickly as possible.</h3>
                <h5>Please Note: Although we can investigate policy coverage for USAA, we are now unable to guarantee the result is consistent with the date of loss.</h5>
            </div>
            }
        </div>
    );
};

export default IntakeSuccess;